import PropTypes from "prop-types"
import React from "react"

import AlertBanner from "src/components/AlertBanner"

const SubmitFailureNotice = ({ failure, copy }) => {
  const { message, terminal, marinaPhone } = failure

  return (
    <AlertBanner type={terminal ? "error" : "warning"}>
      <div className="flex flex-col gap-1">
        <span>{message}</span>
        {terminal && marinaPhone && (
          <a
            className="font-semibold text-blue-600"
            href={`tel:${marinaPhone}`}
          >
            {copy.callMarina}
          </a>
        )}
      </div>
    </AlertBanner>
  )
}

SubmitFailureNotice.propTypes = {
  failure: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string.isRequired,
    terminal: PropTypes.bool,
    marinaPhone: PropTypes.string,
  }).isRequired,
  copy: PropTypes.shape({
    callMarina: PropTypes.string,
  }).isRequired,
}

export default SubmitFailureNotice
